module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"vacancy-not":"У вас нет открытых вакансий на сайте rabota.ru"}}')
  delete Component.options._Ctor
}
